import { css } from "styled-components";
import token from "styled-token";
import { disabledMixin } from "../disabledMixin";
import { spacingMixin } from "../spacingMixin";
import { typographyMixin } from "../typographyMixin";
/** @class LabelMixin */

/** @method */

export var LabelMixin = function LabelMixin(props) {
  var size = props.size;
  return token({
    fontType: "Label.fontTypes." + size,
    optionalColor: "Label.optionalColor",
    asteriskColor: "Label.asteriskColor"
  }, function (tokens) {
    return css(["&:not([aria-disabled=\"true\"]){cursor:pointer;}", " &[data-required=\"true\"]:after{content:\"\\00a0*\";color:", ";}&[data-optional=\"true\"]:after{content:\"\\00a0(optional)\";color:", ";font-weight:normal;}&[aria-disabled=\"true\"]{", "}", ""], typographyMixin(Object.assign({
      fontType: tokens.fontType
    }, props)), tokens.asteriskColor, tokens.optionalColor, disabledMixin(Object.assign({}, props, {
      disabled: true
    })), spacingMixin(props));
  })(props);
};